module.exports = __webpack_public_path__ + "static/media/Jiangsu Sanmu Grouo.e5bdb412.webp";